
import { useState } from 'react';
import { ChevronDown, ChevronUp } from 'lucide-react';
import { Card, CardContent, CardDescription, CardHeader, CardTitle } from "@/components/ui/card";

interface ServiceItemProps {
  title: string;
  description: string;
}

interface ServiceCardProps {
  title: string;
  description: string;
  items: ServiceItemProps[];
  icon: React.ReactNode;
}

const ServiceCard = ({ title, description, items, icon }: ServiceCardProps) => {
  const [isExpanded, setIsExpanded] = useState(false);

  return (
    <Card className="border-l-4 border-gradient-blue-green transition-all duration-500 hover:shadow-xl hover:shadow-blue-primary/20 bg-gradient-to-br from-blue-light to-green-light border-blue-primary hover:scale-[1.02] group">
      <CardHeader className="cursor-pointer py-4" onClick={() => setIsExpanded(!isExpanded)}>
        <div className="flex items-center justify-between">
          <div className="flex items-center gap-3">
            <div className="p-2 bg-gradient-blue-green rounded-full shadow-lg group-hover:scale-110 transition-transform duration-300">
              <div className="text-white">
                {icon}
              </div>
            </div>
            <div>
              <CardTitle className="text-lg text-blue-primary group-hover:text-green-primary transition-colors duration-300">{title}</CardTitle>
              <CardDescription className="text-sm text-gray-600 group-hover:text-gray-800 transition-colors duration-200">{description}</CardDescription>
            </div>
          </div>
          <div className="p-1 rounded-full bg-gradient-light-blue-green">
            {isExpanded ? <ChevronUp className="text-green-primary" size={18} /> : <ChevronDown className="text-blue-primary" size={18} />}
          </div>
        </div>
      </CardHeader>
      {isExpanded && (
        <CardContent className="animate-fade-in pt-0">
          <ul className="space-y-3">
            {items.map((item, index) => (
              <li key={index} className="pl-3 border-l-2 border-gradient-blue-green relative overflow-hidden group/item">
                <div className="absolute left-0 top-0 h-full w-1 bg-gradient-blue-green transform scale-y-0 group-hover/item:scale-y-100 transition-transform duration-300 origin-top"></div>
                <strong className="text-blue-primary group-hover/item:text-green-primary transition-colors duration-200 text-sm">{item.title}:</strong> 
                <span className="text-gray-700 group-hover/item:text-gray-900 transition-colors duration-200 text-sm"> {item.description}</span>
              </li>
            ))}
          </ul>
        </CardContent>
      )}
    </Card>
  );
};

export default ServiceCard;
